import { simpleGlobalState } from '@pbk-web/state';

import type { ScriptexAuthStatus } from '../models/AuthModels';
import type User from '../models/User';

export const useCurrentUser = simpleGlobalState<User | null>(null);

export const useScriptexAuthStatus = simpleGlobalState<ScriptexAuthStatus | null>(null);
